/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon32Regular = forwardRef('MediaAudioVolumeSMinusIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 6.867c0-1.296-1.532-1.982-2.499-1.12L8.619 11H4.75A2.75 2.75 0 0 0 2 13.75v4.5A2.75 2.75 0 0 0 4.75 21h3.869l5.882 5.252c.967.863 2.499.177 2.499-1.119V6.867Zm-7.05 5.625L15 7.983v16.034l-5.05-4.509A2 2 0 0 0 8.62 19H4.75a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75h3.869a2 2 0 0 0 1.332-.508Z" }),
        React.createElement("path", { d: "M20.25 15a1 1 0 1 0 0 2h9.5a1 1 0 1 0 0-2h-9.5Z" })));
});
